import React from 'react';
import styled from 'styled-components';
import {DividerColor} from '../../Colors';

const TextAreaStyle = styled.textarea`
    padding:5px;
    border-radius:5px;
    border: 1px solid ${DividerColor};
    outline: none;
    &:focus{
        background-color:white;
    }
`;

const NoBorderTextAreaStyle = styled.textarea`
        border : none;
		&:focus{
			outline : 0;
		}
`;

const TextArea = React.forwardRef(({borderType='outlined',...props},ref) => {
	if(borderType==='outlined'){
		return <TextAreaStyle {...props} ref={ref}/>;
	}
	return <NoBorderTextAreaStyle ref={ref} {...props}/>;
});

export default  TextArea;